<template>
  <div class="buy">
    <van-form @submit="onSubmit">
      <van-field
        readonly
        v-model="form.entName"
        label="企业名称"
        placeholder="请输入企业名称"
        :rules="rules.entName"
      />
      <van-field
        class="require"
        v-model="form.concat"
        label="联系人"
        placeholder="请输入联系人"
        :rules="rules.concat"
      />
      <van-field
        class="require"
        v-model="form.concatTel"
        label="联系电话"
        placeholder="请输入联系电话"
        :rules="rules.concatTel"
      />
      <van-field
        class="require"
        v-model="form.address"
        label="详细地址"
        placeholder="请输入详细地址"
        :rules="rules.address"
      />
      <van-field
        type="textarea"
        v-model="form.remark"
        label="备注"
        placeholder="请输入备注"
        maxlength="200"
        show-word-limit
      />
      <div class="info">
        <listCom :item="info" num="org"></listCom>
      </div>
      <div class="btn">
        <van-button block type="info" native-type="submit">提交订单</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { getLocalStorage, isPhone, notEmpty } from '@utils'
import { entDetail, insertOrder, entDetailInfo } from '@api/market/index'
import { saveRecord, saveUVRecord } from '@api/lishui/live'
import listCom from './components/list'
import { Toast } from 'vant'
export default {
  components: {
    listCom
  },
  data() {
    return {
      form: {
        goodsId: this.$route.query.id,
        entName: getLocalStorage('entName'),
        concat: '',
        address: '',
        concatTel: '',
        remark: ''
      },
      info: {}, // 商品信息
      rules: {
        concat: [{ required: true, message: '请输入联系人' }],
        address: [{ required: true, message: '请输入详细地址' }],
        concatTel: [notEmpty('正确的手机号'), isPhone()]
      }
    }
  },
  created() {
    this.getEntDetailInfo()
  },
  mounted() {
    this.getEntDetail()
  },
  methods: {
    /** 获取订单信息详情 */
    getEntDetailInfo() {
      entDetailInfo(this.form).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          this.form.address = data.address
          this.form.concat = data.contact
          this.form.concatTel = data.contactTel
        } else {
          Toast(msg)
        }
      })
    },
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      saveRecord(params).then(res => {})
      saveUVRecord(params).then(res => {})
    },
    getEntDetail() {
      entDetail({ id: this.$route.query.id }).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          this.info = data
          this.info.oraimg = data.img.ossUrl
        } else {
          Toast(msg)
        }
      })
    },
    onSubmit() {
      console.log(this.form)
      this.buriedPoint()

      insertOrder(this.form).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          this.$router.push({
            path: '/market/buySuccess'
          })
        } else {
          Toast(msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.buy {
  width: 100%;
  min-height: 100vh;
  background: #f7f7f7;
  /deep/.require {
    &:before {
      content: '*';
      color: red;
      position: absolute;
      left: 9px;
    }
  }
  .van-cell {
    background: #fff;
  }
  .info {
    padding: 0 15px 15px;
  }
  .btn {
    width: 100%;
    background: #fff;
    padding: 10px 15px;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
  }
}
</style>
